var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import AppInfo from "~/components/collection-manage/collection-application/app-info.vue";
import ApproveDetails from '~/components/collection-manage/collection-application/approve-details.vue';
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseApplyManageService } from '~/services/business-service/case-apply-manage.service';
import { FlowConfigurationService } from "~/services/business-service/flow-configuration.service";
var collectionManageModule = namespace("collection-manage");
var AppInfoQuery = /** @class */ (function (_super) {
    __extends(AppInfoQuery, _super);
    function AppInfoQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.rowData = {};
        _this.dataSet = [];
        _this.dialog = {
            appInfo: false,
            approveDetail: false
        };
        _this.queryParamsModel = {
            caseId: "",
            flowType: "CHECK_MATERIAL_APPLY"
        };
        return _this;
    }
    AppInfoQuery.prototype.initiataApply = function () {
        this.dialog.appInfo = true;
    };
    AppInfoQuery.prototype.approveDetail = function (row) {
        this.dialog.approveDetail = true;
        this.rowData = row;
    };
    AppInfoQuery.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.queryParamsModel.caseId = this.caseId;
        this.caseApplyManageService.getProcessApplicationByFlowType(this.queryParamsModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], AppInfoQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AppInfoQuery.prototype, "sortService", void 0);
    __decorate([
        Dependencies(FlowConfigurationService)
    ], AppInfoQuery.prototype, "flowConfigurationService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], AppInfoQuery.prototype, "caseApplyManageService", void 0);
    __decorate([
        collectionManageModule.State
    ], AppInfoQuery.prototype, "caseId", void 0);
    AppInfoQuery = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                AppInfo: AppInfo,
                ApproveDetails: ApproveDetails
            }
        })
    ], AppInfoQuery);
    return AppInfoQuery;
}(Vue));
export default AppInfoQuery;
